import {
    getContact,
    editContact,
    deleteContact,
    searchContact
} from '@/api/ContactController'
import contactStatus from '@/utils/contactStatus'
import common from '@/utils/common'

const contact = {
    namespaced: true,
    state: {
        dataDialogVisible: false,
        detailDialogVisible: false,
        pageLoading: true,
        searchQuery: {
            keywords: '',
            status: '',
            createTime: ''
        },
        listQuery: {
            params: {
                pageSize: common.pagination.pageSize,
                pageNum: 1
            },
            data: {}
        },
        editData: {
            id: '',
            note: '',
            remark: '',
            status: ''
        },
        dataList: {
            total: 0
        }
    },
    mutations: {
        UPDATE_STATE: (state, data) => {
            state[data.key] = data.val
        },
        UPDATE_SEARCH_QUERY: (state, data) => {
            state.searchQuery[data.key] = data.val
        },
        SET_LIST_QUERY: (state, query) => {
            Object.keys(query).forEach((key) => {
                state.listQuery.params[key] = query[key]
            });
        },
        SET_EDIT_OBJ: (state, data) => {
            Object.keys(data).forEach((key) => {
                state.editData[key] = data[key]
            })
        },
        SET_EDIT: (state, data) => {
            state.editData[data.key] = data.val
        },
        SET_SEARCH_QUERY_DEFAULT: (state) => {
            Object.keys(state.searchQuery).forEach(key => {
                state.searchQuery[key] = ''
            })
        },
        SET_PAGE_DEFAULT: (state) => {
            state.listQuery.params.pageNum = 1
        },
        SET_EDIT_DEFAULT: (state) => {
            Object.keys(state.editData).forEach(key => {
                state.editData[key] = ''
            })
        }
    },
    actions: {
        DoSearch(context) {
            return new Promise((resolve, reject) => {
                context.commit('SET_PAGE_DEFAULT')
                context.commit('UPDATE_STATE', { key: 'pageLoading', val: true })
                searchContact(context.state.searchQuery).then(res => {
                    context.commit('UPDATE_STATE', { key: 'pageLoading', val: false })
                    context.commit('UPDATE_STATE', { key: 'dataList', val: res.data })
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        GetList(context) {
            return new Promise((resolve, reject) => {
                context.commit('UPDATE_STATE', { key: 'pageLoading', val: true })
                getContact(context.state.listQuery).then(res => {
                    context.commit('UPDATE_STATE', { key: 'pageLoading', val: false })
                    context.commit('UPDATE_STATE', { key: 'dataList', val: res.data })
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        Edit(context) {
            return new Promise((resolve, reject) => {
                editContact(context.state.editData).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        Delete(context) {
            return new Promise((resolve, reject) => {
                deleteContact(context.state.editData.id).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
    },
    getters: {
        getStatusList() {
            let arr = contactStatus
            let newArr = Object.keys(arr).map(key => {
                return { value: key, label: arr[key] }
            })
            newArr.unshift({ value: '', label: common.setting.all })
            return newArr
        }
    }
}

export default contact
